import React from 'react';

const SponsorKassow2024: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-2xl font-bold mb-4">🤖 BOSCH Rexroth: Membawa Kassow Robots ke Panggung IIT Challenge 2024</h2>
            <p className="mb-6">
                Dalam semangat mendukung generasi muda Indonesia untuk terus berinovasi melalui teknologi, <b>IIT Challenge 2024</b> dengan bangga menggandeng <b>BOSCH Rexroth</b> sebagai sponsor utama. Melalui kolaborasi ini, BOSCH Rexroth menghadirkan <b>Kassow Robots</b>, pionir dalam bidang <i>collaborative robotics</i>, untuk menginspirasi dan mendorong kemajuan otomasi serta digitalisasi di kalangan pelajar Indonesia.
            </p>

            <h3 className="text-2xl font-bold mb-4 mt-6">🔧 Tentang Kassow Robots</h3>
            <p className="mb-6">
                Kassow Robots adalah produsen <i>cobots</i> (collaborative robots) asal Kopenhagen, Denmark yang kini menjadi bagian dari keluarga besar <b>BOSCH Rexroth</b>. Mereka dikenal atas pengembangan cobot 7-axis yang ringan, kuat, dan efisien—dirancang khusus untuk berbagai aplikasi industri yang membutuhkan fleksibilitas tinggi dan kemudahan penggunaan.
            </p>

            <h3 className="text-2xl font-bold mb-4 mt-6">⚙️ Teknologi yang Kuat, Cepat, dan Sederhana</h3>
            <p className="mb-6">
                Cobots dari Kassow Robots tersedia dalam berbagai seri, dengan kemampuan daya angkut mulai dari 5 hingga 18 kg dan jangkauan kerja dari 850 hingga 1800 mm. Kecepatan sendi mencapai 225 derajat per detik memungkinkan mereka beroperasi dengan sangat cepat dan presisi tinggi.
            </p>
            <p className="mb-6">
                Beberapa aplikasi unggulan Kassow Robots mencakup:
            </p>
            <ul className="list-disc list-inside mb-6">
                <li>Welding (Pengelasan)</li>
                <li>Packaging & Palletizing</li>
                <li>CNC & Machine Tending</li>
                <li>Pick & Place</li>
            </ul>

            <h3 className="text-2xl font-bold mb-4 mt-6">🏭 Solusi Fleksibel untuk Semua Skala Industri</h3>
            <p className="mb-6">
                Salah satu kekuatan utama Kassow Robots adalah kemudahan instalasi dan penggunaannya, bahkan oleh UKM yang tidak memiliki spesialis robotika. Desainnya yang ramping dan ringan memungkinkan penggunaan di ruang kerja terbatas tanpa mengorbankan performa.
            </p>

            <h3 className="text-2xl font-bold mb-4 mt-6">💡 BOSCH Rexroth untuk Masa Depan Inovasi</h3>
            <p className="mb-6">
                Dengan prinsip <b>“Strong. Fast. Simple.”</b>, Kassow Robots—dengan dukungan penuh <b>BOSCH Rexroth</b>—tidak hanya menawarkan solusi teknologi, tapi juga membuka jalan bagi efisiensi, fleksibilitas, dan transformasi industri masa depan. Kehadiran mereka di IIT Challenge 2024 mencerminkan komitmen BOSCH Rexroth terhadap pengembangan SDM unggul dan pendidikan teknologi di Indonesia.
            </p>

            <h3 className="text-2xl font-bold mb-4 mt-6">👏 Terima Kasih, BOSCH Rexroth!</h3>
            <p className="mb-6">
                Kami mengucapkan terima kasih atas dukungan BOSCH Rexroth yang telah menghadirkan pengalaman teknologi mutakhir melalui Kassow Robots di IIT Challenge 2024. Semoga kolaborasi ini terus menginspirasi generasi muda untuk berinovasi dan menjadi pelaku transformasi digital di masa depan.
            </p>

            <p className="mt-6">
                🔗 <a href="https://www.kassowrobots.com" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">Pelajari lebih lanjut tentang Kassow Robots</a><br />
                🔗 <a href="https://www.boschrexroth.com" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">Informasi lebih lanjut tentang BOSCH Rexroth</a>
            </p>
        </div>

    );

};

export default SponsorKassow2024;